<template>
    <div class="bulk-actions" ref="elementToDetectOutsideClick">
        <div class="bulk-actions__all">
            <div class="form-field checkbox-wrap">
                <input type="checkbox" id="select_all" @change="onSelectAll" />
                <label for="select_all"
                    ><i class="icon icon-checkmark"></i
                ></label>
            </div>
        </div>
        <div
            class="bulk-actions__dropdown"
            :class="{ 'is-open': is_show_dropdown }"
            @click="toggleDropdown"
        >
            <div class="dropdown-toggle">
                <span></span>
                <span></span>
            </div>
        </div>

        <div
            class="bulk-actions__menu"
            :class="is_show_dropdown ? 'opened' : ''"
        >
            <ul>
                <li
                    v-for="action in menu_actions"
                    @click="
                        onCallAction(
                            action.url,
                            action.validation,
                            action.is_need_submit
                        )
                    "
                >
                    {{ action.name }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "Bulk_Actions",
    props: ["onSelectAll", "menu_actions", "onCallAction"],
    data() {
        return {
            is_show_dropdown: false,
        };
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        toggleDropdown() {
            this.is_show_dropdown = !this.is_show_dropdown;
        },
        onHandleAction(action) {
            action();
            this.is_show_dropdown = false;
        },
        handleClickOutside(event) {
            if (
                !this.$refs.elementToDetectOutsideClick.contains(event.target)
            ) {
                this.is_show_dropdown = false;
            }
        },
    },
};
</script>
